import axios from "axios";

const storeAxios = axios.create({
	baseURL: "/api/1bf33266-a5a6-4ded-a69d-47dd489507d8/",
	withCredentials: true,
	timeout: 3600000,
});

export default storeAxios;
